import { createAction } from '@reduxjs/toolkit';
import type { ReportTemplate } from '~/exportReport/template/reportTemplate';
import type { ExportReportActiveParams } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.state';

export const exportReportEnable = createAction(
  'MAP_SETTINGS_EXPORT_REPORT_ENABLE',
  (params: ExportReportActiveParams) => ({
    payload: { params },
  })
);

export const exportReportDisable = createAction(
  'MAP_SETTINGS_EXPORT_REPORT_DISABLE',
);

export const exportReportSetTemplate = createAction(
  'MAP_SETTINGS_EXPORT_SET_TEMPLATE',
  (template: ReportTemplate) => ({
    payload: { template },
  })
);
